export { DrugsAccordion } from './DrugsAccordion.component';
